import { environmentConfig } from "@src/appV2/environment";

export const BOOKING_REQUESTS_URL = `${environmentConfig.REACT_APP_WORKER_APP_BFF_URL}/booking-requests`;

export const DELETE_BOOKING_REQUEST_URL = `${environmentConfig.REACT_APP_WORKER_APP_BFF_URL}/booking-requests/:bookingRequestId`;
